import React from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {CompanyContanier} from "../optionsStyles";
import CompanyCutOffOptions from "./Options";

const CutOffOptions = ({companyId}) => {
    const stores = useStore();

    const [companyLoading, companyData, setCompanyData, setCompanyLoading] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.companyStore.getCompany.bind(null, {
            companyId,
            withSubCompanies: false,
            vehicleType: null
        }),
        dependencies: []
    });

    return (
        <div data-testid="cutOptionsFilter">
            <h2 data-testid="companyName">{companyData?.data?.companyName}</h2>
            <CompanyContanier>
                <CompanyCutOffOptions companyData={companyData} companyLoading={companyLoading} />
            </CompanyContanier>
        </div>
    );
};

export default CutOffOptions;
